import { render, staticRenderFns } from "./data-subject-preference.vue?vue&type=template&id=4af56c4c"
import script from "./data-subject-preference.vue?vue&type=script&lang=js"
export * from "./data-subject-preference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports